/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleGroupsGroupsInner
 */
export interface RoleGroupsGroupsInner {
    /**
     * 
     * @type {number}
     * @memberof RoleGroupsGroupsInner
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RoleGroupsGroupsInner
     */
    name?: string;
}

/**
 * Check if a given object implements the RoleGroupsGroupsInner interface.
 */
export function instanceOfRoleGroupsGroupsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function RoleGroupsGroupsInnerFromJSON(json: any): RoleGroupsGroupsInner {
    return RoleGroupsGroupsInnerFromJSONTyped(json, false);
}

export function RoleGroupsGroupsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleGroupsGroupsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function RoleGroupsGroupsInnerToJSON(value?: RoleGroupsGroupsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

